import { createReducer } from '@reduxjs/toolkit';
import { WidgetPresence } from 'lib-shared-legacy-types';

import { widgetActions } from './widget.actions';

export interface WidgetState {
  presence?: WidgetPresence;
}

export const initialState: WidgetState = {};

export const widgetReducer = createReducer(initialState, (builder) => {
  builder.addCase(widgetActions.setPresence, (state, action) => {
    state.presence = action.payload.presence;
  });
});
